import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreateMpptQuantityFilterNode from './MpptQuantityFilterNodeFactory'

const useMpptQuantityFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreateMpptQuantityFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default useMpptQuantityFilterNode
